import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ArrowLeftToolTip = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 61}
          height={props.height ?? 68}
          viewBox="0 0 61 68"
          fill="none"
          {...props}
        >
          <Path
            d="M19.804 45.8171L17.4967 46.5877C16.0935 47.0949 14.8675 47.4008 13.8657 47.7211L12.4916 48.1477L11.3744 48.4521C10.7201 48.6406 10.2236 48.7991 9.85254 48.9348C8.36518 49.469 8.89621 49.6504 8.9714 49.9797C9.0466 50.3091 8.66117 50.669 10.3028 50.5286C10.7101 50.4884 11.2456 50.4195 11.9442 50.3087L13.125 50.1194L14.5614 49.7785C15.6043 49.5271 16.8896 49.2335 18.3494 48.7445L20.7334 47.9796C21.5891 47.68 22.4716 47.3205 23.4423 46.9573C27.9519 45.1767 32.281 42.9691 36.3705 40.3647C40.7966 37.5356 44.9079 34.2419 48.6345 30.5396C51.6115 27.614 54.2882 24.3976 56.6244 20.9387C57.3326 19.9131 57.9826 18.8485 58.5714 17.7499C58.9988 16.9765 59.1984 16.533 59.1352 16.4973C58.7813 16.2587 54.6586 22.8721 47.4074 29.3746C43.6126 32.8268 39.4929 35.9039 35.1057 38.5629C31.0654 41.0023 26.8267 43.0969 22.4347 44.8244L19.8274 45.8132"
            fill="black"
          />
          <Path
            d="M9.27982 44.7452C10.7174 42.354 11.9508 40.1788 12.9309 38.358C14.9373 34.6436 15.9525 32.2096 15.5213 31.9485C15.09 31.6875 13.2952 33.6234 10.7289 37.0056C9.44833 38.6911 7.98517 40.7228 6.39065 43.0165C5.597 44.1851 4.80725 45.3153 3.91843 46.6953C3.32908 47.5638 2.98875 48.577 2.93434 49.6252C2.9291 50.3711 3.14516 51.1018 3.55522 51.7249C3.95567 52.317 4.4813 52.814 5.09494 53.1807C5.9486 53.6402 6.83375 54.0386 7.74375 54.3729C8.52281 54.7236 9.33694 54.9963 10.1188 55.2813C11.6875 55.8401 13.2056 56.3628 14.6658 56.8059C17.5923 57.7082 20.2573 58.3589 22.5155 58.8132C27.0369 59.7106 29.8817 59.8132 29.9619 59.3674C30.042 58.9217 27.3587 57.9549 23.0816 56.4848C20.9375 55.7473 18.4445 54.8929 15.6154 53.8337C14.2236 53.3278 12.764 52.7645 11.2648 52.1701L8.99887 51.2572C8.29705 50.9946 7.61301 50.6867 6.95105 50.3355C6.51256 50.0311 6.60269 50.0985 6.56542 49.8542C6.61432 49.3595 6.7824 48.884 7.05524 48.4685C7.82831 47.197 8.58634 45.9588 9.28705 44.7886"
            fill="black"
          />
        </Svg>
      </View>
    );
  },
);

export { ArrowLeftToolTip };
